import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react'

interface MarketingCardContextType {
  marketingCardIndex: number
  updateMarketingCardIndex: (_: number) => void
}

const MarketingCardContext = createContext<MarketingCardContextType>({
  marketingCardIndex: 0,
  updateMarketingCardIndex: () => {},
})

const useMarketingAnalysisCard = (): MarketingCardContextType => {
  const context = useContext(MarketingCardContext)
  if (context === undefined) {
    throw new Error('useMarketingAnalysisCard is not available')
  }
  return context
}

interface MarketingCardProviderProps {
  children: ReactNode
}

const MarketingAnalysisProvider = ({
  children,
}: MarketingCardProviderProps) => {
  const [marketingCardIndex, setMarketingCardIndex] = useState<number>(0)

  const updateMarketingCardIndex = useCallback((index: number) => {
    setMarketingCardIndex(index)
  }, [])

  const contextValue: MarketingCardContextType = {
    marketingCardIndex,
    updateMarketingCardIndex,
  }

  return (
    <MarketingCardContext.Provider value={contextValue}>
      {children}
    </MarketingCardContext.Provider>
  )
}

export {
  MarketingCardContext,
  MarketingAnalysisProvider,
  useMarketingAnalysisCard,
}
